/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Method_Change_KiotvietInputs */

const vi_error_payment_method_change_kiotviet = /** @type {(inputs: Error_Payment_Method_Change_KiotvietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn này đồng bộ từ KiotViet nên không đổi hình thức thanh toán ở đây được.`)
};

/**

* @param {Error_Payment_Method_Change_KiotvietInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_method_change_kiotviet = /** @type {((inputs?: Error_Payment_Method_Change_KiotvietInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Method_Change_KiotvietInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_method_change_kiotviet(inputs)
});